export default __webpack_public_path__ + "static/media/VOTE.a40e7e9b.png";